import type { ModuleManifest } from "./types";

export const offerDetailsManifest: ModuleManifest = {
  name: "offer-details",
  label: "Offer Detail",
  labelPlural: "Offer Details",

  coreBOSModule: "cbOfferDetail",
  wsidPrefix: "66x",

  type: "standard",

  routes: {
    list: "/offer-details",
    show: "/offer-details/show/:id",
    create: "/offer-details/create",
    edit: "/offer-details/edit/:id",
  },

  navigation: {
    icon: "UnorderedListOutlined",
    order: 9,
    group: "Sales",
    hidden: true, // Detail modules are accessed via master, not directly
  },

  routing: {
    keywords: ["offer detail", "offer line", "quote line", "offer item"],
    searchFields: ["cbofferdetailno", "offerdetail_code"],
    defaultSort: { field: "sequence_no", order: "asc" },
  },

  context: {
    supported: false,
  },

  fields: [
    { name: "cbofferdetailno", label: "Detail No", type: "string", readonly: true },
    { name: "related_product", label: "Product", type: "reference", referenceModule: "Products", required: true },
    { name: "cboffers_relation", label: "Offer", type: "reference", referenceModule: "cbOffers", required: true },
    { name: "offerdetail_code", label: "Code", type: "string" },
    { name: "unit_price", label: "Unit Price", type: "currency" },
    { name: "offerdetail_rate", label: "Quantity", type: "number" },
    { name: "offerdetail_condition", label: "Condition", type: "picklist" },
    { name: "related_pricebook", label: "Price Book", type: "reference", referenceModule: "PriceBooks" },
    { name: "sequence_no", label: "Sequence", type: "number" },
    { name: "net_price", label: "Net Price", type: "currency" },
    { name: "vat_tax", label: "VAT %", type: "number" },
    { name: "vat_value", label: "VAT Amount", type: "currency" },
    { name: "assigned_user_id", label: "Assigned To", type: "reference", referenceModule: "Users", hidden: true, defaultValue: "19x1" },
  ],

  relationships: [
    { module: "cbOffers", field: "cboffers_relation", label: "Offer", icon: "FileTextOutlined", displayField: "subject" },
    { module: "Products", field: "related_product", label: "Product", icon: "ShoppingOutlined", displayField: "productname" },
  ],

  requiredFields: ["related_product", "cboffers_relation", "assigned_user_id"],

  massEdit: {
    enabled: false,
  },
};
